import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'
import ManagersActions from 'store/models/managers'
import SupplierActions from 'store/models/supplier'
import AnimatedLogo from '@wellbeingxltd/fe-lib/images/dist/logo/AnimatedLogo.gif'
import './styles.scss'

const NoAccessPage = () => {
    const dispatch = useDispatch()
    const { managers } = useSelector(GET_STORE.MANAGERS)
    const { supplier } = useSelector(GET_STORE.SUPPLIER)

    useEffect(() => {
        document.title = 'Error | Betterspace Supplier'

        if (!managers.length) {
            dispatch(ManagersActions.getManagers())
        }
        if (!supplier) {
            dispatch(SupplierActions.getSupplier())
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (!supplier) {
        return (
            <div className="centerLoader">
                <img src={AnimatedLogo} width="128px" alt="Full screen loading spinner" />
            </div>
        )
    }
    return (
        <div>
            <h1>Sorry, you don't have permission to access any pages</h1>
            <p>
                This is likely a mistake. Please contact your admin {!!supplier ? `(${supplier.primaryContactEmail}) ` : ''}and ask them to update the
                permissions for your email on the Managers section on the Settings page.
            </p>
        </div>
    )
}

export default NoAccessPage
